import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import copy from 'copy-to-clipboard'

import { toaster, SelectMenu, Button, Position } from 'evergreen-ui'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMapMarkerAlt,
  faArrowAltCircleRight,
  faTruck,
  faPersonBooth,
  faCheckSquare,
  faSearch,
  faExclamationCircle,
  faClock,
  faExclamationTriangle,
  faHourglassHalf,
  faStoreAlt,
  faBoxOpen,
  faCircleNotch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { apiService, translateService } from '../services'
import TimeLine from './TimeLine'


import {
  changeTranslationSelectorState,
  changeTranslationTargetLanguage,
} from '../redux/Tracefully/AppSettings'

const mapDispatchToProps = function mapDispatch(dispatch) {
  return bindActionCreators({
    changeTranslationSelectorState: changeTranslationSelectorState,
    changeTranslationTargetLanguage: changeTranslationTargetLanguage,
  }, dispatch)
}
const mapStateToProps = function mapState(state) {
  return {
    AppSettings: state.AppSettings,
    UserSettings: state.UserSettings,
  }
}

class TrackItem extends Component {


  constructor(props) {
    super(props)


    this.state = {
      extended: false,
      canExtend: false,

      isTranslate: false,
      carrier: null,
      selectedCarrier: 'aggregated',
      selectedCarrierName: 'Aggregated',
      Carriers: [
        { label: 'Aggregated', value: 'aggregated' },
      ],
      showMap: false,
      markers: [],
      parcelTrack: '',
      bounds: null,
      trackCheckpoints: [],
      translation: {},
      checkpoints: [],
    }
  }

  componentDidMount() {


    this.addCarrier(this.props.item.tracks)
    //let mapresult = this.getMarkers()
    //this.setState({ markers: mapresult.marker, parcelTrack: mapresult.markerArr, bounds: mapresult.bounds })
    // console.log(this.props.item)

  }


  componentDidUpdate(prevProps) {

    // reset page if items array has changed

    if (this.props.item.currentProcess.running == false  && prevProps.item.currentProcess.running == true) {

      this.addCarrier(this.props.item.tracks)
      //let mapresult = this.getMarkers()
      //this.setState({ markers: mapresult.marker, bounds: mapresult.bounds })
    }
  }


  onChangeCarrier(selected) {

    if (selected.value === 'aggregated') {
      this.setState({
        carrier: null,
        checkpoints: this.props.item.aggregated_checkpoints,
        selectedCarrier: selected.value,
        selectedCarrierName: selected.label,
      })
    } else {
      console.log(selected.value)
      console.log(this.props.item)
      this.setState({
        carrier: selected,
        checkpoints: this.props.item.tracks[selected.value].checkpoints,
        selectedCarrier: selected.value,
        selectedCarrierName: selected.label,
      })
    }

  }

  Extend() {
    console.log('extend');
    if(this.state.canExtend){
      this.setState((prevState) => {
        return { extended: !prevState.extended }
      })
    }


  }

  getMarkers() {

    let markerArr = []
    let cordArray = []
    let marker = ''
    for (let i = 0; i < this.props.item.aggregated_checkpoints.length; i++) {
      if (this.props.item.aggregated_checkpoints[i].position !== '' && this.props.item.aggregated_checkpoints[i].position !== null && this.props.item.aggregated_checkpoints[i].position.accuracy >= 2) {
        if (cordArray.length > 0 && this.props.item.aggregated_checkpoints[i].position.location.loc.coordinates !== cordArray[cordArray.length - 1]) {
          marker =
            <Marker position={this.props.item.aggregated_checkpoints[i].position.location.loc.coordinates}>
              <Popup>{this.props.item.aggregated_checkpoints[i].position.formatted_address_short}</Popup>
            </Marker>

          markerArr.push(
            <Polyline key={i} positions={[
              cordArray[cordArray.length - 1], this.props.item.aggregated_checkpoints[i].position.location.loc.coordinates,
            ]} color='#2869fa'/>,
          )
          cordArray.push(this.props.item.aggregated_checkpoints[i].position.location.loc.coordinates)
        } else {


          marker =
            <Marker position={this.props.item.aggregated_checkpoints[i].position.location.loc.coordinates}>
              <Popup>{this.props.item.aggregated_checkpoints[i].position.formatted_address_short}</Popup>
            </Marker>

          cordArray.push(this.props.item.aggregated_checkpoints[i].position.location.loc.coordinates)
        }
      }
    }
    let bounds = null
    if (cordArray.length > 2) {
      let x0 = null
      let x1 = null
      let y0 = null
      let y1 = null
      for (let t = 0; t < cordArray.length; t++) {
        if (x0 == null) {
          x0 = x1 = cordArray[t][0]
          y0 = y1 = cordArray[t][1]
        } else {
          if (cordArray[t][0] > x1) x1 = cordArray[t][0]
          if (cordArray[t][0] < x0) x0 = cordArray[t][0]
          if (cordArray[t][1] > y1) y1 = cordArray[t][1]
          if (cordArray[t][1] < y0) y0 = cordArray[t][1]
        }
      }
      bounds = [[x0, y0], [x1, y1]]
    }
    return { marker: marker, markerArr: markerArr, bounds: bounds }
  }

  openOriginBox(e) {
    console.log('show Origin')
    e.stopPropagation()
  }

  openDestinationBox(e) {
    console.log('Show Destination')
    e.stopPropagation()
  }

  copyTrackingnr(e, tnr) {
    copy(tnr)
    toaster.success('Copied to Clipboard (Tracking Number)', {
      description: tnr,
      id: 'forbidden-action',
      duration: 3,
      zIndex: 12000,
    })
    e.stopPropagation()
  }

  openTrackMap(e) {
    console.log('Show Track Map')
    this.setState((prevState) => {
      return { showMap: !prevState.showMap }
    })
    e.stopPropagation()
  }

  copyDetails(e) {
    console.log('Copy Details')
    if (this.state.checkpoints.length > 0) {
      let pasteresult = ''
      for (let i = this.state.checkpoints.length - 1; i >= 0; i--) {
        console.log('checkpoint')
        let row = ''
        let day = new Date(this.state.checkpoints[i].timestamp)
        row = day.toLocaleString('default', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
        row += '\t'
        if (this.state.checkpoints[i].message !== '') {
          row += this.state.checkpoints[i].message
        } else {
          row += this.state.checkpoints[i].text
        }
        row += '\n'
        pasteresult += row
      }
      console.log(pasteresult)
      copy(pasteresult)
      toaster.success('Copied to Clipboard (Details)', {
        id: 'forbidden-action',
        duration: 3,
        zIndex: 12000,
      })
    } else {
      toaster.notify('Nothing to copy')
    }

    e.stopPropagation()
  }

  copyLink(e) {
    // console.log('https://track.tracefully.com?tn='+this.props.item.trackingNr);
    copy('https://track.tracefully.com?tn=' + this.props.item.trackingNr)
    toaster.success('Copied to Clipboard (Link)', {
      description: 'track.tracefully.com?tn=' + this.props.item.trackingNr,
      id: 'forbidden-action',
      duration: 3,
      zIndex: 12000,
    })
    // navigator.clipboard.writeText('https://t.trackfully.com?tn='+this.props.item.trackingNr)
    e.stopPropagation()
  }

  openOrder(e, id) {
    history.push('/order?id=' + id + '&shop=' + this.props.UserSettings.Shop.myshopify_url, '_blank')
    if(e != null){
      e.stopPropagation()
    }

  }



  changeLanguage(e) {
    this.props.changeTranslationSelectorState(true)
    e.stopPropagation()
  }

  async translate(e) {
    e.stopPropagation()
    if (e.target.checked === true) {
      this.setState({ isTranslate: true })
      try {
        if (typeof this.state.translation[this.props.AppSettings.translationTargetLanguage.geo] === 'undefined') {
          console.log('Translation needed - init api request')
          let response = await translateService.translate(
            this.props.AppSettings.translationTargetLanguage.geo,
            this.state.selectedCarrier,
            this.props.item.trackingNr,
          )
          console.log(response)
          if (response.translation && response.translation.length > 0) {
            this.setState({
              checkpoints: response.translation,
            })

            this.props.onUpdateTranslation(response.translation, this.state.selectedCarrier)

          } else {
            toaster.notify('Translation failed', { description: 'Please try again later.' })
          }


        } else {
          console.log('Translation already available no need to retranslate')
        }


      } catch (err) {
        console.log(err)
        toaster.notify('Translation failed', { description: 'Please try again later.' })
      }

    } else {
      this.setState({ isTranslate: false })
      console.log('revert to old translation')
    }


  }

  buildDestinationBlock() {

    let returnBlock = []
    let originCountry = ''
    let originCarrier = ''

    if (this.props.item.origin_country != null) {
      originCountry = this.props.item.origin_country.name
    }

    if (this.props.item.origin_carrier != null) {
      originCarrier = this.props.item.origin_carrier.fullname
    }
    let oriBlock =
      <div role="button" key="oriBlock" id="w-node-02e438ee9410-43cb7079" className="oridesblock alignright"
           onClick={(e) => this.openOriginBox(e)}>
        <div className="oridesdirectioncontainer">
          <div>Origin</div>
        </div>
        <div id="w-node-02e438ee9414-43cb7079" className="oridescountrycontainer">
          <div className="text-block-92">{originCountry}</div>
        </div>
        <div id="w-node-02e438ee9417-43cb7079" className="oridescarriercontainer">
          <div>{originCarrier}</div>
        </div>
      </div>

    returnBlock.push(oriBlock)
    returnBlock.push(
      <div
        key="connectBlock"
        id="w-node-02e438ee941a-43cb7079"
        className="trackingdirection">

        <FontAwesomeIcon
          className="image-36"
          size="2x"
          icon={faArrowAltCircleRight}
        />
      </div>,
    )

    let destinationCountry = ''
    let destinationCarrier = ''
    if (this.props.item.destination_country != null) {
      destinationCountry = this.props.item.destination_country.name
    }

    if (this.props.item.destination_carrier != null) {
      destinationCarrier = this.props.item.destination_carrier.fullname
    }
    let destBlock = (
      <div role="button" key="destBlock" className="oridesblock"
           id="destinationBlock"
           onClick={(e) => this.openDestinationBox(e)}>
        <div className="oridesdirectioncontainer">
          < div> Destination</div>
        </div>
        <div id="w-node-02e438ee9420-43cb7079"
             className="oridescountrycontainer">
          <div className="text-block-93"> {destinationCountry}
          </div>
        </div>
        <div id="w-node-02e438ee9423-43cb7079" className="oridescarriercontainer">
          <div>{destinationCarrier}</div>
        </div>
      </div>)
    returnBlock.push(destBlock)

    return returnBlock

  }

  buildLastRecordBlock() {
    let returnBlock = ''
    let rotateChevronStyle = {
      transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(180deg) skew(0deg, 0deg)',
      transformStyle: 'preserve-3d',
    }

    if (this.state.checkpoints.length > 0) {
      let lastItemIndex = this.state.checkpoints.length - 1
      let postionTag = ''
      let day = new Date(this.state.checkpoints[lastItemIndex].timestamp)  // 2009-11-10
      let month = day.toLocaleString('default', { month: 'short' })
      let formatDay = day.getDate() + ' ' + month + ' ' + day.getFullYear()
      let message = ''
      if (typeof this.state.checkpoints[lastItemIndex].message === 'object') {
        console.log('is object')
      } else if (this.state.checkpoints[lastItemIndex].message !== '') {
        message = this.state.checkpoints[lastItemIndex].message
      } else {
        message = this.state.checkpoints[lastItemIndex].text
      }


      let trackCheckpoints = []
      for (let i = 0; i < this.state.checkpoints.length; i++) {
        if (this.state.checkpoints[i].position !== null &&
          this.state.checkpoints[i].position !== '') {
          trackCheckpoints.push(this.state.checkpoints[i].position.location)
        }
      }

      this.state.trackCheckpoints = trackCheckpoints



      if (this.state.checkpoints[lastItemIndex].position !== null &&
        this.state.checkpoints[lastItemIndex].position !== '') {
        postionTag =
          <div className="lastrecordmap">
            <div role="button" className="maptag" >
              <div role="button"
                   className="trackingmaptagtext">{this.state.checkpoints[lastItemIndex].position.formatted_address_short}
              </div>
              <FontAwesomeIcon
                style={{ marginTop: '2px', marginLeft: '2px', color: '#36a4ff' }}
                icon={faMapMarkerAlt}/>
            </div>
          </div>
      }


        returnBlock = (
            <div id="w-node-02e438ee9426-43cb7079" className="recordcontainer">
              <div className="lastrecordcontainer">
                <div className="lastrecordheadercontainer">
                  <div id="w-node-02e438ee9429-43cb7079" className="lastrecorddate">
                    <div className="lastrecordtext">Last Record:</div>
                    <div className="lastrecorddatetag">
                      <div className="lastrecorddatetext">{formatDay}</div>
                    </div>
                  </div>

                  {postionTag}

                </div>
                <div className="lastrecordbody">
                  <div className="lastmessagetext"><strong className="bold-text-2">{message}</strong></div>
                </div>
              </div>

              {!this.props.forceExpanded &&(
                  <div id="w-node-02e438ee9438-43cb7079" className="expandcontrol"><img
                      src="https://uploads-ssl.webflow.com/5efc669c581d3b4a35e28a40/5f087490e0114b65faaf5625_chevron-down-solid.svg"
                      alt="" className="chevron"
                      style={(this.state.extended && this.state.canExtend) ? rotateChevronStyle : {}}/>
                  </div>
              )}



            </div>
        )



    }else if(this.props.item.status =='Not Found' && !this.props.item.currentProcess.running){
      returnBlock = (
          <div id="w-node-02e438ee9426-43cb7079" className="recordcontainer">
            <div className="lastrecordcontainer">

              <div className="lastrecordbody">
                <div className="lastmessagetext"  style={{marginTop:'0px'}}><strong className="bold-text-2 vurox-color-red-6">Tracking information could not be found. Please try again later.</strong></div>
              </div>
            </div>
          </div>
      )
    }else{
      returnBlock = (
          <div id="w-node-02e438ee9426-43cb7079" className="recordcontainer">
            <div className="lastrecordcontainer">

              <div className="lastrecordbody">
                <div className="lastmessagetext"  style={{marginTop:'0px'}}> We are loading the tracking information for your number. This might take a few seconds.</div>
              </div>
            </div>
          </div>
      )
    }


    return returnBlock
  }

  buildStateBlock() {
    let returnBlock = ''
    let iconContainer = ''
    let time = ''
    if ((this.props.item.status === null||this.props.item.status === '') && this.props.item.last_track === null) {
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Yellow">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faHourglassHalf}/>
          </div>
        </div>)
    } else if (this.props.item.status === null||this.props.item.status === '') {
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Yellow">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faHourglassHalf}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'Delivered') {
      let diffTime = Math.abs(new Date(this.props.item.shipped_date) - new Date(this.props.item.delivery_date))
      time = ' (' + Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + ' days)'
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Green">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faCheckSquare}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'In Transit') {
      let diffTime = Math.abs(new Date(this.props.item.shipped_date) - new Date())
      time = ' (' + Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + ' days)'
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Blue">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faTruck}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'Out For Delivery') {
      let diffTime = Math.abs(new Date(this.props.item.shipped_date) - new Date())
      time = ' (' + Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + ' days)'
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Purple">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faPersonBooth}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'Not Found') {
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Gray">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faSearch}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'Warning') {
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Orange">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faExclamationCircle}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'Expired') {
      let diffTime = Math.abs(new Date(this.props.item.shipped_date) - new Date())
      time = ' (' + Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + ' days)'
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Orange">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faClock}/>
          </div>
        </div>)
    } else if (this.props.item.status === 'Exception') {
      iconContainer = (
        <div className="shippingstateiconcontainer stateIcon-Red">
          <div className="shippingstateicon">
            <FontAwesomeIcon
              style={{ width: '26px', height: '26px' }}
              icon={faExclamationTriangle}/>
          </div>
        </div>)
    }
    if (this.props.item.currentProcess.running == true) {
      returnBlock = (
        <div className="itemstatuscontainer">
          <div className="shippingstateiconcontainer stateIcon-Ghost">
            <div className="shippingstateicon">
              <FontAwesomeIcon
                className='fa-spin'
                style={{ width: '26px', height: '26px', color:'#007DF6' }}
                icon={faCircleNotch}/>
            </div>
          </div>
          <div className="trackinginfo">
            <div className="div-block-196">
              <div role="button" className="trackingnrtext"
                   onClick={(e) => this.copyTrackingnr(e, this.props.item.trackingNr)}>{this.props.item.trackingNr}
              </div>
            </div>
            <div className="div-block-195">
              <div className="trackingstatetext">LOADING</div>
            </div>
          </div>
        </div>
      )
    } else if (this.props.item.status != null && this.props.item.status != '') {
      returnBlock = (
        <div className="itemstatuscontainer">
          {iconContainer}
          <div className="trackinginfo">
            <div className="div-block-196">
              <div role="button" className="trackingnrtext"
                   onClick={(e) => this.copyTrackingnr(e, this.props.item.trackingNr)}>{this.props.item.trackingNr}
              </div>
            </div>
            <div className="div-block-195">

              <div className="trackingstatetext">{this.props.item.status}{time}</div>
            </div>
          </div>
        </div>
      )
    } else {
      returnBlock = (
        <div className="itemstatuscontainer">
          {iconContainer}
          <div className="trackinginfo">
            <div className="div-block-196">
              <div className="trackingnrtext">{this.props.item.trackingNr}</div>
            </div>
            <div className="div-block-195">

              <div className="trackingstatetext">Queued</div>
            </div>
          </div>
        </div>
      )
    }

    return returnBlock
  }

  addCarrier(items) {
    let tracks = Object.keys(items)
    if (tracks.length > 0) {
      let carrierArr = [
        { label: 'Aggregated', value: 'aggregated' },
      ]
      if (tracks.length === 1) {
        carrierArr = [{
          label: items[tracks[0]].carrier.fullname,
          value: items[tracks[0]].carrier.name,
          icon: 'https://cdn.tracefully.com/carriers/' + items[tracks[0]].carrier.name + '.svg',
        }]
        this.setState({
          canExtend: true,
          Carriers: carrierArr,
          checkpoints: items[tracks[0]].checkpoints,
          selectedCarrier: items[tracks[0]].carrier.name,
          selectedCarrierName: items[tracks[0]].carrier.fullname,
        })
      } else {
        for (let i = 0; i < tracks.length; i++) {
          if (items[tracks[i]].result === true && items[tracks[i]].checkpoints.length > 0) {
            carrierArr.push(
              {
                label: items[tracks[i]].carrier.fullname,
                value: items[tracks[i]].carrier.name,
                icon: 'https://cdn.tracefully.com/carriers/' + items[tracks[i]].carrier.name + '.svg',
              },
            )
          }
        }
        this.setState({
          Carriers: carrierArr,
          canExtend: true,
          checkpoints: this.props.item.aggregated_checkpoints,
        })
      }
    } else {
      this.setState({ canExtend: false })
    }
  }

  async markRetrack(trackingNr) {
    console.log('retrack',trackingNr);
    let response = await apiService.markForRetrack(trackingNr);
    if(response && response.retrack == true){
      toaster.success('Order has been marked for retrack',{description:'The Server will use the next available tracking slot to retrack the number. This might take a few minutes.'})
    }else if(response && response.retrack== false){
      toaster.warning('Order has not been marked for retrack',{description:response.message})
    }else{
      toaster.danger('Order has not marked for retrack',{description:'Internal error'})
    }
    console.log(response);
  }

  reportError(trackingNr){

    this.props.onReportError(trackingNr);
  }

  render() {

    const directionBlock = this.buildDestinationBlock()

    const lastRecordBlock = this.buildLastRecordBlock()

    const stateBlock = this.buildStateBlock()
    /*
    -----------------------------------------------
    tags:


     */
    // const markers = this.getMarkers();
    return (

      <div className="trackitem" id={this.props.item.trackingNr} key={this.props.item.trackingNr}>

        <div
          role="button"
          data-w-id="fe6c57d1-f97e-b1d1-33c8-02e438ee9403"
          id="trackitembody"
          onClick={(e) => this.Extend(e)}
          className={
            ((this.state.extended||this.props.expanded) && this.state.canExtend ) ? 'trackitembody trackitemexpanded' : 'trackitembody'
          }>
          <div className="w-layout-grid grid-3">
            {stateBlock}


            <div className="trackinfocontainer">

              {directionBlock}


            </div>
            {lastRecordBlock}
          </div>
        </div>
        {this.state.showMap && (
          <div className='mapContainer'>
            <div role="button" className='mapCloseContainer' onClick={(e) => this.openTrackMap(e)}>
              <FontAwesomeIcon
                style={{ width: '21px', height: '21px' }}
                icon={faTimes}/>

            </div>
            <div style={{ height: '350px', width: '100%', overflow: 'hidden' }}>
              <div className={"t1_mapContainer"}>

                <Map
                    center={[25, 25]}
                    zoom={7}
                    bounds={this.state.bounds}
                    boundsOptions={{ padding: [15, 15] }}
                >
                  <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
                  />
                  {this.state.marker}

                </Map>


              </div>


            </div>

          </div>

        )}

        {((this.state.extended && this.state.canExtend)||(this.state.canExtend && this.props.forceExpanded)) && (
          <div data-w-id="fbd4f237-41d9-6e74-1d83-0683fed4db7e" className="trackitemtimeline">
            <div className="carrierSelector controlsTranslateContainer pull-right">
              Carrier:
              <SelectMenu
                hasTitle={false}
                hasFilter={false}
                title="Select carrier"
                options={
                  this.state.Carriers
                }
                selected={this.state.selectedCarrier}
                onSelect={item => this.onChangeCarrier(item)}
                position={Position.BOTTOM_RIGHT}
              >
                <Button className='controllsButton ml-1' height={24} appearance="minimal"
                        onClick={(e) => this.copyDetails(e)}>
                  {this.state.selectedCarrierName}
                </Button>
              </SelectMenu>

            </div>

            <div className="timelinecomponentcontainer">

              <TimeLine
                checkpoints={this.state.checkpoints}
                useTranslation={this.state.isTranslate}
                carrier={this.state.carrier}
              />

            </div>
            <div className="timelinecontrolscontainer">

              <Button className='controllsButton ml-1' height={24} appearance="minimal"
                      onClick={(e) => this.copyDetails(e)}>
                Copy Details
              </Button>

              <Button className='controllsButton' height={24} appearance="minimal"
                      onClick={(e) => this.copyLink(e)}>
                Copy Link
              </Button>




            </div>
          </div>

        )}


      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrackItem)


/* Translate Component*/

/*
<div className="controlsTranslateContainer pull-right">
                Translate:
                <Button className='controlsLanguageSelect' height={24} appearance="minimal"
                        onClick={(e) => this.changeLanguage(e)}>
                  {this.props.AppSettings.translationTargetLanguage.name}
                </Button>

                <input
                  style={{ marginRight: '8px', marginLeft: '4px' }}
                  type="checkbox"
                  value={this.state.isTranslate}
                  onClick={(e) => this.translate(e)}
                />

              </div>
 */
